/** Redact private infrastructure details without normalizing conversation prose. */
export function providerConversationText(value: unknown): string | null {
  if (typeof value !== "string" || !value.trim()) return null;
  return value
    .replace(/-----BEGIN [A-Z0-9 ]*PRIVATE KEY-----[\s\S]*?-----END [A-Z0-9 ]*PRIVATE KEY-----/gi, "[private key redacted]")
    .replace(/\bBearer\s+[A-Za-z0-9._~+/-]+/gi, "Bearer [redacted]")
    .replace(/\b(?:sk-(?:proj-)?[A-Za-z0-9_-]{16,}|sbp_[a-zA-Z0-9]{20,}|eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+)\b/g, "[credential redacted]")
    .replace(/\b((?:api[_ -]?key|client[_ -]?secret|refresh[_ -]?token|access[_ -]?token|password)\s*[:=]\s*)(?:"[^"\r\n]*"|'[^'\r\n]*'|[^\s,;]+)/gi, "$1[redacted]")
    .replace(/https?:\/\/[^\s<>"'`]+/gi, (url) => {
      try {
        const parsed = new URL(url);
        return /(?:^|\.)(?:base44\.com|base44\.app|base44-preview\.app|provider\.app)$/i.test(parsed.hostname) ||
            parsed.hostname.includes("preview-sandbox--") ||
            [...parsed.searchParams.keys()].some((key) => /token|ticket|secret|signature|credential/i.test(key))
          ? "[private link]" : url;
      } catch { return url; }
    })
    .replace(/\b(?:base44[_ -]?app[_ -]?id|provider[_ -]?app[_ -]?id)\s*[:=]\s*[A-Za-z0-9-]+/gi, "App reference: [private]")
    .replace(/\b(?:create_base44_app|edit_base44_app|get_app_status|base44_prompt)\b/gi, "App operation")
    .replace(/\bBase44\b/gi, "Provider");
}
